var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9651 13.2098C14.8029 13.0935 15.4811 12.4727 15.6407 11.6582C15.8004 10.7662 15.96 9.44727 16 7.81818C16 6.18909 15.8004 4.87018 15.6407 3.97818C15.4815 3.16364 14.8029 2.54291 13.9651 2.42655C12.6084 2.23273 10.4538 2 7.98 2C5.50618 2 3.31164 2.23273 1.99491 2.42655C1.15709 2.54291 0.478909 3.16364 0.319273 3.97818C0.159636 4.87018 0 6.18909 0 7.81818C0 9.44727 0.159636 10.7662 0.319273 11.6582C0.478545 12.4727 1.15709 13.0935 1.99491 13.2098C3.35164 13.4036 5.54618 13.6364 7.98 13.6364C10.4538 13.6364 12.6484 13.4036 13.9651 13.2098ZM6.18182 5.06651V10.5701C6.18182 10.8407 6.48291 11.0018 6.708 10.8523L10.836 8.10033C11.0371 7.96615 11.0371 7.67088 10.836 7.53706L6.708 4.78506C6.48291 4.63488 6.18182 4.79633 6.18182 5.06651Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic-youtube.7ffe05d1bb8d52501a07c07537ff4006.svg";
export { ForwardRef as ReactComponent };